// import Pictogram from 'components/common/Pictogram';
import Link from 'next/link';
import React from 'react';
import LeftArrow from './left-arrow.svg';
import styles from './styles.scss';

interface Props {
  title?: string;
  children?: React.ReactNode;
  backButtonHref?: string;
  backButtonAs?: string;
}

const TopBar = ({ title, children, backButtonAs, backButtonHref }: Props): JSX.Element => {
  const showBackButton = backButtonAs && backButtonHref;

  return (
    <section className={styles.container} data-testid="topbar">
      <div className={styles.topBar}>
        <div className={styles.content}>
          <div className={styles.middleContainer}>
            {showBackButton && (
              <Link href={backButtonHref} as={backButtonAs}>
                <a className={styles.backButton}>
                  <LeftArrow />
                </a>
              </Link>
            )}
            {title && <span className={styles.title}>{title}</span>}
            {/*
            <Link href="/" as="/">
              <a className={styles.logo}>
                <Pictogram />
              </a>
            </Link>
            */}
          </div>
          {children && children}
        </div>
      </div>
    </section>
  );
};

TopBar.defaultProps = {
  title: null,
  backButtonHref: null,
  backButtonAs: null,
};

export default TopBar;
